<template>
  <div class="modal is-active" :class="modalPartnerClass">
    <div class="modal-background"></div>
    <div class="modal-card">
      <section class="modal-card-body" :class="{footerless : !this.hasFooter}">
        <div v-if="title" class="modal-header title mb-0 is-4 has-text-centered">{{title}}</div>
        <div v-if="text" class="modal-text is-centered columns has-text-centered" v-html="text"></div>
        <div v-if="hasInput" class="modal-input">
          <input id="inputField" class="input" type="text" :placeholder="inputPlaceHolder" v-model="inputValue" @keyup.enter="success" @keyup.esc="cancel"/>
          <div v-if="isInlineImage" class="inline-image control is-flex has-text-primary">
            <label class="radio is-size-5 has-text-weight-semibold"><input type="radio" name="answer" v-model="imageAlignment" value="left">&nbsp;Left</label>
            <label class="radio is-size-5 has-text-weight-semibold"><input type="radio" name="answer" v-model="imageAlignment" value="center">&nbsp;Center</label>
            <label class="radio is-size-5 has-text-weight-semibold"><input type="radio" name="answer" v-model="imageAlignment" value="right">&nbsp;Right</label>
            <input class="input" type="text" placeholder="Image Caption" v-model="caption" @keyup.enter="success" @keyup.esc="cancel"/>
          </div>
        </div>
        <section v-if="isDisplayingQuestions" class="submit-questions">
          <div class="questions is-block" v-for="(question, questionIndex) in questions" :key="question.id">
            <section v-if="question.type === 'text'">
              <label v-if="question.label.length >= 40" class="label">{{question.label}}</label>
              <generic-input
                  v-model="question.givenAnswer"
                  :idAndName="question.question"
                  :placeholder="question.labels.en">
              </generic-input>
            </section>
            <fieldset :id="question.labels.en">
              <div v-if="question.type === 'radio'" class="radio-question" >
                <h4 class="option-title">{{ question.labels.en }}</h4>
                <div class="radio-container">
                  <label class="radio-option is-flex" v-for="option in question.answers" :key="option.id" >
                    <input class="radio-button" type="radio" :name="question.labels.en" :value="option.id" v-model="question.givenAnswer">
                    {{ option.value }}
                  </label>
                </div>
              </div>
            </fieldset>
            <section v-if="question.type === 'list'" class="question-inputs">
              <label v-if="question.labels.en.length >= 40" class="label">{{question.labels.en}}</label>
              <generic-dropdown
                  v-model="question.givenAnswer"
                  :idAndName="question.question"
                  :items="question.answers"
                  :placeholder="question.labels.en.length < 40 ? question.labels.en : ''"
                  :isUp="questionIndex > (questions.length - 1)/2">
              </generic-dropdown>
            </section>
          </div>
        </section>
        <section v-if="showDeclineQuestions" class="submit-questions">
          <div class="questions is-block">
            <fieldset>
              <div class="radio-question">
                <div class="radio-container">
                  <label class="radio-option" v-for="option in declineReasons" :key="option.id" >
                    <br><input class="radio-button" type="radio" :name="option.Text" :value="option.id" v-model="reason">
                    {{ option.Text }}
                  </label>
                </div>
              </div>
              <h4 class="option-title mt-2">Add Custom Message (Optional)</h4>
              <input class="question-inputs-decline mt-1" v-model="customMessage" data-lpignore="true"/>
            </fieldset>
          </div>
        </section>
        <div v-if="errorMessage" class="help has-text-danger is-size-6 has-text-centered">{{ errorMessage }}</div>
      </section>
      <footer v-if="hasFooter" class="modal-card-foot btn-center">
        <button v-if="successText" @click="success" class="button success-button is-primary" :class="getGTMSuccess()">{{successText}}</button>
        <button v-if="cancelText" @click="cancel" class="button cancel-button" :class="getGTMCancel()">{{cancelText}}</button>
        <div v-if="footerText" class="footer-text">{{footerText}}</div>
      </footer>
      <button v-if="hasClose" @click="close" class="delete close-button" aria-label="close"></button>
    </div>
  </div>
</template>

<script>
import imageProxy from '@/libs/image-proxy'
import componentState from '@/mixins/component-state'
import GenericDropdown from '@/components/Controls/GenericComponents/dropdown'
import GenericInput from '@/components/Controls/GenericComponents/input'

export default {
  mixins: [componentState],
  components: {
    GenericDropdown,
    GenericInput
  },
  props: ['hasClose', 'hasFooter', 'footerText', 'hasInput', 'filledInput', 'title', 'text',
    'isInlineImage', 'successText', 'cancelText', 'justifyButtons', 'gtmSuccess', 'gtmCancel',
    'templateID', 'projectID', 'questions', 'isDeclined'],

  data: function () {
    return {
      seenModal: true,
      inputValue: '',
      caption: '',
      imageAlignment: 'center',
      errorMessage: '',
      declineReasons: [],
      reason: '',
      customMessage: ''
    }
  },
  mounted: function () {
    if (this.filledInput) {
      this.inputValue = this.filledInput
      document.getElementById('inputField').setAttribute('readonly', true)
    }

    if (this.showDeclineQuestions) {
      this.$store.dispatch('getDeclineReasons').then((response) => {
        this.declineReasons = response.reasons
      })
    }
  },
  created: function () {
    this._callback('lockScrolling', false)
  },
  destroyed: function () {
    this._callback('unlockScrolling', true)
  },
  computed: {
    inputPlaceHolder: function () {
      return this.isInlineImage ? 'Image Url' : ''
    },
    modalPartnerClass: function () {
      return 'modal-' + process.env.APP_NAME.toLowerCase()
    },
    isDisplayingQuestions: function () {
      return this.templateID > 0 && this.projectID > 0
    },
    showDeclineQuestions: function () {
      return this.isDeclined && this.$isIsef
    }
  },
  methods: {
    success: function () {
      if (this.showDeclineQuestions) {
        var array = this.declineReasons
        var id = this.reason
        var text = ''
        array.forEach(function (entry) {
          var x = entry.id
          if (x === id) {
            text = entry.Text
          }
        })

        var params = [this.reason, this.customMessage, text]
        this.$emit('selectedReason', params)
      }
      if (this.isInlineImage) {
        const args = { url: this.inputValue, alignment: this.imageAlignment, caption: this.caption }
        this.$emit('modalSuccess', args)
      } if (this.isDisplayingQuestions && this.questions) {
        const tags = []
        this.questions.forEach((question) => {
          if (!question.givenAnswer && !question.optional) {
            this.errorMessage = this.$t('projectPage.submissionModalError')
            return
          }
          if (question.givenAnswer) {
            let answer
            if (question.givenAnswer.tag) {
              answer = question.givenAnswer.tag
            } else if (question.givenAnswer.value) {
              answer = question.givenAnswer.value.replace('/', '-')
              answer = answer.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
              answer = answer.replace(/([ ()/])*/g, '')
            } else {
              answer = question.givenAnswer
            }
            tags.push(answer)
          }
        })
        if (tags.length === 0) {
          return this.$emit('modalSuccess')
        }

        const requiredQuestions = this.questions.filter((question) => !question.optional)

        if (tags.length >= requiredQuestions.length) {
          this.$store.dispatch('submitProjectTags', { projectID: this.projectID, tags }).then((response) => {
            this.$emit('modalSuccess')
          }, () => {
            this.errorMessage = this.$t('projectPage.failedToSaveSubmitAnswers')
          })
        }
      } else {
        this.$emit('modalSuccess', this.hasInput ? { url: this.inputValue } : null)
      }
    },
    cancel: function () {
      this.$emit('modalCancel')
    },
    close: function () {
      this.$emit('modalClose')
    },
    getGTMSuccess: function () {
      if (this.gtmSuccess) {
        return this.gtmSuccess
      }
    },
    getGTMCancel: function () {
      if (this.gtmSuccess) {
        return this.gtmSuccess
      }
    },
    thumbnail: imageProxy.thumbnail
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .label {
    font-size: 0.9rem;
  }
  .question-inputs {
    margin-bottom: 5rem;
    width: 90%rem;
    margin: auto;
  }

  .question-inputs-decline {
    margin-bottom: 1rem;
    width: 20em;
  }

  .close-button {
    position: absolute;
    right: 1.5rem;
    top: 1.5rem;
  }

  .modal-card-body {
    padding: 15px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }

  .modal-text {
    padding: 1rem;
  }

  .modal-header{
    padding: 1.5rem 3rem 1.5rem 3rem;
    margin: 0;
  }

  .footerless {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }

  .modal-card-foot {
    padding: 1rem 3rem;
  }

  .btn-center {
    justify-content: center;
  }

  .button {
    border-radius: 0;
  }
  .modal-input {
    padding: 3rem;
  }

  .inline-image {
    margin-top: 1rem;
    margin-bottom: 1rem;
    width: 100%;
    justify-content: space-between;
  }

  .modal-make {
    @import './stylesMake.scss';
  }

  .modal-neweng {
    @import './stylesNeweng.scss';
  }
</style>
